import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

require('intersection-observer')

Vue.use(VueObserveVisibility)
